import Vue from "vue";

export async function getLeadAndService(service_number) {
    const response = await Vue.prototype.$http.post(
        `/eps/get_lead_and_service`, { 
            service_number
         }
    );

    return response.data
}